import './App.css';
import Rota from './Rota';

function App() {
  return (
    <div>
     <Rota />
    </div>
  );
}

export default App;
